import { TextWithHighlight } from '@dixa/lib-shared-habla';
import type { SearchCompany } from 'lib-shared-types-api';

import { useAppSearchParams } from 'utils/url/useAppSearchParams';

import { ContactsListItem } from '../../../listItem/contactsListItem';

interface ContactsCompanyProps {
  company: SearchCompany;
  selected?: boolean;
}

export function ContactsCompany({
  company,
  selected,
}: ContactsCompanyProps): JSX.Element {
  const {
    params: { q: searchTerm = '' },
  } = useAppSearchParams('/contacts/company/:id');

  return (
    <ContactsListItem
      primaryLabel={
        <TextWithHighlight text={company.name} highlight={searchTerm} />
      }
      avatar={company}
      appLinkProps={{
        path: '/contacts/company/:id',
        params: {
          path: { id: company.id },
          search: { q: searchTerm },
        },
      }}
      selected={selected}
    />
  );
}
